module.exports = "\n.loading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(129, 128, 128, 0.1);\n  z-index: 9999;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/tabs/user/tickets/tickets.component.css
// module id = ./src/app/pages/admin/icontact/tabs/user/tickets/tickets.component.css
// module chunks = main